import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'JOB_ACTIVATE_ERROR':
      return action.error;
    case 'JOB_ACTIVATE_RESET':
      return null;
    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'JOB_ACTIVATE_LOADING':
      return action.loading;
    case 'JOB_ACTIVATE_RESET':
      return false;
    default:
      return state;
  }
}

export function activated(state = null, action) {
  switch (action.type) {
    case 'JOB_ACTIVATE_SUCCESS':
      return action.activated;
    case 'JOB_ACTIVATE_RESET':
      return null;
    default:
      return state;
  }
}

export default combineReducers({ error, loading, activated });
